function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.23267 0.826597C7.23267 0.37008 7.60275 0 8.05926 0C8.51578 0 8.88586 0.37008 8.88586 0.826597V1.94253H14.4243V0.826597C14.4243 0.37008 14.7944 0 15.2509 0C15.7074 0 16.0775 0.37008 16.0775 0.826597V1.94253H21.3675C22.2148 1.94253 23.31 2.93445 23.31 3.98836V6.24083C23.31 6.32349 23.2687 6.36482 23.1861 6.36482H0.12399C0.0413299 6.36482 0 6.32349 0 6.24083V3.98836C0 2.83112 1.13657 1.94253 1.90117 1.94253H7.23267V0.826597ZM16.0175 4.12952C16.0175 4.68241 15.5693 5.13061 15.0164 5.13061C14.4635 5.13061 14.0153 4.68241 14.0153 4.12952C14.0153 3.57662 14.4635 3.12842 15.0164 3.12842C15.5693 3.12842 16.0175 3.57662 16.0175 4.12952ZM17.6445 5.13059C18.2319 5.13059 18.7081 4.68238 18.7081 4.12949C18.7081 3.5766 18.2319 3.12839 17.6445 3.12839C17.057 3.12839 16.5808 3.5766 16.5808 4.12949C16.5808 4.68238 17.057 5.13059 17.6445 5.13059ZM21.2732 4.12949C21.2732 4.68238 20.811 5.13059 20.2408 5.13059C19.6707 5.13059 19.2084 4.68238 19.2084 4.12949C19.2084 3.5766 19.6707 3.12839 20.2408 3.12839C20.811 3.12839 21.2732 3.5766 21.2732 4.12949Z",
  fill: "#D18F1F"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 7.75735C0 7.67469 0.0413299 7.63336 0.12399 7.63336H23.1861C23.2687 7.63336 23.31 7.67469 23.31 7.75735V21.6855C23.31 22.8014 22.4215 24 21.0369 24H2.14915C1.11591 24 0 23.0081 0 21.6855V7.75735ZM6.42366 14.7428V12.6709H4.20467V14.7428H2.3147V16.7307H4.20467V18.8026H6.42366V16.7307H8.32128V14.7428H6.42366ZM15.0162 16.7379V14.7357H21.0228V16.7379H15.0162ZM8.50908 19.064H10.705L14.7912 12.4512H12.5776L8.50908 19.064Z",
  fill: "#D18F1F"
});
function SvgDailyChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyChange);
export default __webpack_public_path__ + "static/media/daily-change.4ecaf23fcfa18f59fbc72e717aab380e.svg";
export { ForwardRef as ReactComponent };